import axios from './util/axios.js'

export function getFedExOptIn () {
  return axios.get('/fedex-opt-in/')
}
